<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Mei Story" bg="/images/board/story/visual.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <board-list code="story" locale="en" skin="card" v-if="!$route.params._board" />
            <board-view code="story" :_id="$route.params._board" skin="card" v-else />
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";

import BoardList from '@/components/client/board/board-list.vue';
import BoardView from '@/components/client/board/board-view.vue';

export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        BoardList,
        BoardView,
    },
}
</script>